module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av533-7d60e4b20d7ddf8d27b97e22ea4b2e32.jpg";